import { ComponentType } from 'react';
import { useGetAuthorizedTabsSelector } from 'core/redux/selectors/authSelectors';
import UnauthorizedAccess from 'pages/UnauthorizedAccess';

const GuardedRoute = ({ tab, children }: { tab: string; children: React.ReactNode }) => {
    const { authorizedTabs } = useGetAuthorizedTabsSelector();
    return authorizedTabs.includes(tab) ? <>{children}</> : <UnauthorizedAccess />;
};

export const guarded =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (tab: string, Component: ComponentType<any>): ComponentType<any> =>
    (props) => {
        const { authorizedTabs } = useGetAuthorizedTabsSelector();
        return authorizedTabs.includes(tab) ? <Component {...props} /> : <UnauthorizedAccess />;
    };

export default GuardedRoute;
